import React, { useState } from 'react';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import ReactionIcon from 'components/Chat/ReactionIcon';
import _ from 'lodash';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
const AVAILABLE_EMOJIS = ['applause','rire','emu','colere'];

const EmojisBar = ({
  onEmojiClick,
  reactionsQueue,
  removeFirstReaction,
  className,
}) => {
  const reactions=_.groupBy(reactionsQueue,'msg');
  const [visible, setVisible] = useState(false);
  return (
    <div className={classNames('emoji-bar', className)}>
      {AVAILABLE_EMOJIS.map((id) => (
        <IconButton
          key={id}
          aria-label={`emoji ${id}`}
          onClick={() => onEmojiClick(id)}
        >
          <ReactionIcon
            id={id}
            reactions={reactions[id]}
            removeFirstReaction={removeFirstReaction}
            visible={visible}
            onDoubleClick={(e) => { e.stopPropagation(); onEmojiClick(id); }}
          />
        </IconButton>
      ))}
      <IconButton
        className={classNames('emoji-wrapper', className)}
        style={{color:'#FFF',opacity:0.7}}
        onClick={()=>setVisible(!visible)}
      >
        {visible ? <VisibilityIcon/> : <VisibilityOffIcon/>}
      </IconButton>
    </div>
  );
};

export default EmojisBar;
